import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class SupplierQueryCriteriaClass extends BaseCriteriaModel {
    //header, bl_fi_mst_entity_hdr table
    hdr_name ?: Optional<string> = Optional.empty();
    txn_type ?: Optional<string> = Optional.empty();
    /**
    * @param hdr_guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5
    */
    hdr_guids ?: Optional<string> = Optional.empty();

    //extension, bl_fi_mst_entity_ext table
    param_code ?: Optional<string> = Optional.empty();
    param_name ?: Optional<string> = Optional.empty();
    param_type ?: Optional<string> = Optional.empty();
    value_string ?: Optional<string> = Optional.empty();
    value_numeric ?: Optional<number> = Optional.empty();
    value_datetime ?: Optional<string> = Optional.empty();
    ext_created_date ?: Optional<string> = Optional.empty();
    ext_updated_date ?: Optional<string> = Optional.empty();
    ext_status ?: Optional<string> = Optional.empty();
}

export class SupplierCriteriaModelQuery {
  query = '';

  constructor(SupplierCriteriaModel: SupplierQueryCriteriaClass) {

    if (!SupplierCriteriaModel) {
      return;
    }

    this.query += SupplierCriteriaModel.hdr_name.filter(x => x !== '').map(x => '&hdr_name=' + x).orElse('');
    this.query += SupplierCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += SupplierCriteriaModel.hdr_guids.filter(x => x !== '').map(x => '&hdr_guids=' + x).orElse('');

    this.query += SupplierCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += SupplierCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += SupplierCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += SupplierCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += SupplierCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');
    this.query += SupplierCriteriaModel.value_datetime.filter(x => x !== '').map(x => '&value_datetime=' + x).orElse('');
    this.query += SupplierCriteriaModel.ext_created_date.filter(x => x !== '').map(x => '&ext_created_date=' + x).orElse('');
    this.query += SupplierCriteriaModel.ext_updated_date.filter(x => x !== '').map(x => '&ext_updated_date=' + x).orElse('');
    this.query += SupplierCriteriaModel.ext_status.filter(x => x !== '').map(x => '&ext_status=' + x).orElse('');

    this.query += '&status=' + SupplierCriteriaModel.status;
    this.query += '&orderBy=' + SupplierCriteriaModel.orderBy;
    this.query += '&order=' + SupplierCriteriaModel.order;
    this.query += '&offset=' + SupplierCriteriaModel.offset + '&limit=' + SupplierCriteriaModel.limit;
  }
}
